import { SpriteTypes, spriteCategory } from '../types/sprite-types'
import { uuid } from '@/libs/src/utils/tools'
const options = {
    visible: true,
    width: 100,
    height: 100,
    lineWidth: 0, radio: true, imageRatio: true,isBottom:true,disableAnchor:true,
}

export default [
    {
        id: uuid(),
        name: "控制面板",
        type: SpriteTypes.sprite,
        icon:'icon-kongzhi',
        categrory: spriteCategory.bg,
        data: {
            ...options,
            name:'DeviceController',
            width:950,
            height:600,
        },
    },
    {
        id: uuid(),
        name: "3D场景",
        type: SpriteTypes.sprite,
        icon:'icon-3D',
        categrory: spriteCategory.bg,
        data: {
            ...options,
            name:'ThreeModel',
            width:500,
            height:500,
        },
    },
    {
        id: uuid(),
        name: "通知面板",
        type: SpriteTypes.sprite,
        icon:'icon-tongzhi',
        categrory: spriteCategory.bg,
        data: {
            ...options,
            name:'DeviceController',
            width:500,
            height:400,
        },
    },
    {
        id: uuid(),
        name: "地图",
        type: SpriteTypes.sprite,
        icon:'icon-ditu',
        categrory: spriteCategory.bg,
        data: {
            ...options,
            name:'AMapLibs',
            width:500,
            height:500,
        },
    },
    {
        id: uuid(),
        name: "直播/录像",
        type: SpriteTypes.sprite,
        icon:'icon-zhibo',
        categrory: spriteCategory.bg,
        data: {
            ...options,
            name:'DeviceController',
            
        },
    },
    {
        id: uuid(),
        name: "二维码生成",
        type: SpriteTypes.sprite,
        icon:'icon-erweima',
        categrory: spriteCategory.bg,
        data: {
            ...options,
            name:'qrcode'
        },
    },
]